import axios from "axios";
import { Message } from "element-ui";
import { getToken } from "@/util/session";
import router from "@/router";
//import baseUrl from "@/env";
let instance = axios.create({
  timeout: 1000000,
  //Sheng: add cookie for loadbalancer mechanism
  withCredentials: true
});
// 添加请求拦截器
instance.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    let token = getToken();
    config.headers.Authorization = token;
    config.responseType = "text";
    config.withCredentials = true;
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    if (response.status !== 200) {
      Message.error("请求服务器错误");
      return Promise.reject("请求服务器错误");
    } else if (response.data.code === 1502 || response.data.code === 1500) {
      Message.error(response.data.message);
      router.push({
        name: "login"
      });
      return Promise.reject({
        authExpired: true,
        code: response.data.code,
        message: response.data.message
      });
    }
    return response;
  },
  error => {
    // 对响应错误做点什么
    console.log(error);
    Message.error(`网络错误，请重新操作:${error}`);
    return Promise.reject(error);
  }
);

export default instance;
